import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Scale, Clock } from "lucide-react";

export default function LegalServices() {
  return (
    <div data-testid="legal-page">
      <SEO title="Legal Services · Coming Soon" description="Tharlo's legal services — document verification, title checks, and property due diligence — coming soon." />
      <section className="min-h-[70vh] bg-white flex items-center">
        <div className="container-tharlo grid grid-cols-1 lg:grid-cols-2 gap-12 items-center py-16">
          <div>
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-gold bg-gold/10 border border-gold/30 px-3 py-1.5 mb-6">
              <Clock className="w-3 h-3" /> Coming Soon
            </div>
            <h1 className="font-display text-4xl lg:text-6xl text-ink tracking-tight">Legal Services</h1>
            <p className="mt-6 text-foreground/70 leading-relaxed max-w-md">
              Tharlo's legal services network — document verification, title checks, due diligence, and registry support — is <strong>currently not available</strong>. We are working with trusted property lawyers to launch this soon. Stay tuned.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/properties" data-testid="legal-cta-properties" className="btn-primary">Explore Properties</Link>
              <Link to="/contact" className="btn-outline">Contact Tharlo</Link>
            </div>
          </div>
          <div className="relative bg-ink text-white p-10 lg:p-12">
            <Scale className="w-10 h-10 text-gold mb-5" />
            <h2 className="font-display text-2xl mb-4">What's coming</h2>
            <ul className="space-y-3 text-sm text-white/80">
              {["Document Verification", "Title Verification", "Ownership Checks", "Property Due Diligence", "Registry Support", "Legal Consultation"].map((s) => (
                <li key={s} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-gold" /> {s}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
